module.exports = __webpack_public_path__ + "static/Hyundai Grand I10-bf858c70c27256b27520a6df033504ad.png";